import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { OutcomeCaseStudyArticle } from "@/components/resources/OutcomeCaseStudyArticle";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { articleJsonLdForPillar } from "@/components/site/PillarArticle";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import body from "../../content/resources/fashionable-canes-shopify-seo-case-study.en.md?raw";

const PATH = "/resources/fashionable-canes-seo-case-study";
const ALT = "/es/recursos/caso-fashionable-canes-seo";
const TITLE = "Fashionable Canes: 15,000+ SKUs, Shopify Theme Migration and SEO Recovery";
const META_TITLE = "Fashionable Canes Shopify SEO Case Study · Shugert";
const DESCRIPTION = "How Fashionable Canes migrated a 15,000+ SKU Shopify theme, recovered rankings within 60 days, and recorded +180% organic traffic and a 350% ROI lift.";
const PUBLISHED = "2026-08-20T14:30:00.000Z";
const MODIFIED = "2026-08-20T14:30:00.000Z";

const SOURCES = [
  { label: "Shugert Marketing partner profile", publisher: "Shopify", href: "https://www.shopify.com/partners/directory/partner/shugert-marketing" },
  { label: "Fashionable Canes", publisher: "Fashionable Canes", href: "https://fashionablecanes.com/" },
  { label: "Published project outcomes", publisher: "Shugert", href: "https://shugert.com.mx/work" },
  { label: "SEO documentation", publisher: "Google Search Central", href: "https://developers.google.com/search/docs" },
];

const RELATED = [
  { label: "Llantas Cavazos migration case study", href: "/resources/llantas-cavazos-migration-case-study" },
  { label: "Shopify technical SEO", href: "/shopify-technical-seo" },
  { label: "Shopify performance", href: "/shopify-performance" },
  { label: "All Shopify case studies", href: "/work" },
];

export const Route = createFileRoute("/resources/fashionable-canes-seo-case-study")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en", title: META_TITLE, description: DESCRIPTION, path: PATH, altPath: ALT, type: "article",
    author: "Samuel Noriega", articleAuthor: "Samuel Noriega", articleSection: "Shopify SEO case study", publishedTime: PUBLISHED, modifiedTime: MODIFIED,
    jsonLd: [
      articleJsonLdForPillar({ title: TITLE, description: DESCRIPTION, path: PATH, publishedTime: PUBLISHED, modifiedTime: MODIFIED, section: "Shopify SEO case study" }),
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Work", path: "/work" }, { name: "Fashionable Canes case study", path: PATH }]),
    ],
  }),
  component: () => (
    <SiteShell>
      <OutcomeCaseStudyArticle
        locale="en" path={PATH} title={TITLE}
        excerpt="How an established Shopify retailer modernized a 15,000+ SKU storefront while protecting search demand, recovering rankings within 60 days, and recording material organic and ROI gains."
        body={body} updated="August 2026" publishedAt={PUBLISHED} modifiedAt={MODIFIED} readingMinutes={11}
        focus="How theme migration, technical SEO recovery, structured data, crawlability, and commercial keyword ownership were coordinated around a large live catalog."
        audience="Established Shopify brands planning a theme migration or SEO recovery where existing organic revenue and catalog scale make regressions expensive."
        sources={SOURCES} related={RELATED}
        category="Shopify SEO & theme migration case study" backLabel="← Work" backHref="/work"
        cta={{ eyebrow: "Large-catalog SEO", title: "Protect search demand before your next theme migration.", body: "We scope the technical SEO, template, catalog, performance, and launch risks before changing the storefront so the migration has measurable commercial acceptance criteria.", label: "Request a technical scope", href: "/get-a-quote?intent=seo&source=fashionable-canes-case-study" }}
      />
    </SiteShell>
  ),
});
